module.exports = __webpack_public_path__ + "static/media/cookTop.217d191c.png";